import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { notificationTypeItems } from "../../utils/enum";
import { playNotificationSound } from "../../utils";
import {
  notificationErrorMessage,
  notificationInfoMessage,
  notificationSuccessMessage,
  notificationWarningMessage,
} from "../../utils/toastMessage/toastMessage";
import { setMetaAction } from "../../redux/actions/metaActions/metaActions";

const NotificationListener = () => {
  const dispatch = useDispatch();

  const socket = useSelector((state) => state.socket);

  const showNotification = (item) => {
    dispatch(setMetaAction());

    const text = item.description;
    playNotificationSound(item.type);

    switch (item.type) {
      case notificationTypeItems[0]:
        notificationSuccessMessage(text);
        break;
      case notificationTypeItems[1]:
        notificationErrorMessage(text);
        break;
      case notificationTypeItems[2]:
        notificationInfoMessage(text);
        break;
      case notificationTypeItems[3]:
        notificationWarningMessage(text);
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    if (!isEmpty(socket)) {
      socket.on("new-notification", showNotification);

      return () => {
        socket.off("new-notification", showNotification);
      };
    }
  }, [socket]);

  return null;
};

export default NotificationListener;
